// extracted by mini-css-extract-plugin
export var text = "FormattedText-module__text___EWb2z";